<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  >
      <template slot="currency" slot-scope="row">
          {{ row.item.currency_name }}
    </template>
  </thux-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as PRICE_LIST_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'PriceListTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'currency',
          label: this.$t('Currency'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          custom: true
        },
        {
          key: 'date_begin',
          label: this.$t('Date begin'),
          type: 'date',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'date_begin'
        },
        {
          key: 'date_end',
          label: this.$t('Date end'),
          type: 'date',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'date_end'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'name', 'note']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: PRICE_LIST_TYPES.GENERIC.price.pricelist.LIST.GETTERS.selectAll,
      selectedList: PRICE_LIST_TYPES.GENERIC.price.pricelist.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm(['price_pricelist_retrieve', 'price_pricelistitem_list'])
    }
  },
  methods: {
    ...mapMutations({
      setList: PRICE_LIST_TYPES.GENERIC.price.pricelist.LIST.MUTATIONS.setList,
      setSelectedList:
        PRICE_LIST_TYPES.GENERIC.price.pricelist.LIST.MUTATIONS.setSelectedList,
      setSelectAll: PRICE_LIST_TYPES.GENERIC.price.pricelist.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...PRICE_LIST_TYPES.GENERIC.price.pricelist.LIST.ACTIONS
    })
  }
}
</script>
